export enum UserRole {
  Admin = 'Admin',
  Manager = 'Manager',
  Reviewer = 'Reviewer',
  Previewer = 'Previewer',
}

export interface User {
  user_id?: string;
  first_name: string;
  last_name: string;
  full_name: string;
  email: string;
  client_user_id: string;
  manager: string;
  roles: string[];
  data: string[];
  created_at: string;
  updated_at: string;
  last_active: string;
  has_manager_role: boolean;
  tenant_id: string;
}
